export const isValidUKPostcode = (postcode: string) => {
  // Regular expression for validating UK postcodes
  const postcodeRegex =
    /^(([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9]?[A-Za-z]))))\s?[0-9][A-Za-z]{2}))$/;

  return postcodeRegex.test(postcode);
};

export const getValidationInputProps = (flag: Boolean) => {
  return {
    borderColor: flag ? 'green.500' : 'red.500',
    _hover: { borderColor: flag ? 'green.500' : 'red.500' },
    _focus: { borderColor: flag ? 'green.500' : 'red.500' },
  };
};
